import { render } from "./EscalationBoard.vue?vue&type=template&id=521fda68"
import script from "./EscalationBoard.vue?vue&type=script&lang=js"
export * from "./EscalationBoard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__